// Prix publics renvoyés par l'API (achat HT + marge, calculé côté serveur).
export const euro = (value) => `${Number(value).toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €`;

export function priceNote(price) {
  if (!price) return "";
  return `Prix affiché sur le site : ${euro(price.price_ht)} HT (La Réunion : ${euro(price.price_ttc_reunion)} TTC ; Mayotte : TVA non applicable)`;
}
